export default __webpack_public_path__ + "static/media/logoIcon.9df63ddf.png";